import i18nVoucherType from './vi/dictionary/i18nVoucherType';
import i18nMain from './vi/i18nMain';
import i18nValidate from './vi/i18nValidate';
import i18nComponent from './vi/i18nComponent';
import i18nEnum from './vi/i18nEnum';
import i18nCommon from './vi/i18nCommon';
import i18nBaseForm from './vi/i18nBaseForm';
import i18nNumber from './vi/i18nNumber';
import i18nMonitor from './vi/monitor/i18nMonitor';
import i18nHelpLink from './vi/i18nHelpLink';
import i18nPages from './vi/i18nPages';
import i18nLocalBudgetItem from './vi/dictionary/i18nLocalBudgetItem';
import i18nInventoryItem from './vi/dictionary/i18nInventoryItem';
import i18nStatistic from './vi/dictionary/i18nStatistic';
import i18nContract from './vi/views/dictionary/i18nContract';
import i18nSettingFinancialReport from './vi/dictionary/i18nSettingFinancialReport';
import i18nPAOption from './vi/dictionary/i18nPAOption';
import i18nNpsServey from './vi/dictionary/i18nNpsServey';
import i18nEtreasuryProcess from './vi/etreasury/i18nEtreasuryProcess';
import i18nDVCSign from './vi/etreasury/i18nDVCSign';
import i18nINTransfer from './vi/dictionary/i18nINTransfer';
import i18nSubmitReport from './vi/views/summary/i18nSubmitReport';
import i18nDVCFile from './vi/etreasury/i18nDVCFile';
/**
 * Dưới đây là import i18n theo nghiệp vụ của các màn hình
 */
import i18nActivityCategory from './vi/views/dictionary/i18nActivityCategory';
import i18nConnectMisaApp from './vi/views/connect/i18nConnectMisaApp';
import i18nGeneralVoucher from './vi/views/summary/i18nGeneralVoucher';
import i18nOutward from './vi/views/tool/i18nOutward';
import i18nToolsProcess from './vi/views/tool/i18nToolsProcess';

// Danh mục
import i18nFixedAsset from './vi/views/dictionary/i18nFixedAsset';
import i18nInventoryCategory from './vi/views/dictionary/i18nInventoryCategory';
import i18nEquipmentInventoryItem from './vi/views/dictionary/i18nEquipmentInventoryItem';
import i18nDIAccountTransfer from './vi/views/dictionary/i18nDIAccountTransfer';
import i18nDefaultImplicitSetting from './vi/views/dictionary/i18nDefaultImplicitSetting';
import i18nDIAutoBusiness from './vi/views/dictionary/i18nDIAutoBusiness';
import i18nDIBudgetProvide from './vi/views/dictionary/i18nDIBudgetProvide';
import i18nDISubBudgetItem from './vi/views/dictionary/i18nDISubBudgetItem';
import i18nBankInfo from './vi/views/dictionary/i18nBankInfo';
import i18nFund from './vi/views/dictionary/i18nFund';
import i18nActivity from './vi/views/dictionary/i18nActivity';
import i18nBranch from './vi/views/dictionary/i18nBranch';
import i18nBudgetSource from './vi/views/dictionary/i18nBudgetSource';
import i18nSuIncrement from './vi/views/tool/i18nSuIncrement';
import i18nSuDecrement from './vi/views/tool/i18nSuDecrement';
import i18nSuTransfer from './vi/views/tool/i18nSuTransfer';
import i18nInInward from './vi/views/tool/i18nInInward';
import i18nAccountTransfer from './vi/views/summary/i18nAccountTransfer';
import i18nAccountingObjectCategory from './vi/views/dictionary/i18nAccountingObjectCategory';
import i18nBUReceiveBudgetPlan from './vi/views/budgetPlan/i18nBUReceiveBudgetPlan';
import i18nBUReceipt from './vi/views/budgetPlan/i18nBUReceipt';
import i18nBUExpense from './vi/views/budgetPlan/i18nBuExpense';
import i18nHamlet from './vi/views/dictionary/i18nHamlet';
import i18nRegimePosted from './vi/views/dictionary/i18nRegimePosted';
import i18nBankInfoCategory from './vi/views/dictionary/i18nBankInfoCategory.js';
import i18nListAccountingObject from './vi/views/dictionary/i18nListAccountingObject.js';
import i18nDepartment from './vi/views/dictionary/i18nDepartment.js';
import i18nBudgetChapter from './vi/dictionary/i18nBudgetChapter';
import i18nBudgetKindItem from './vi/views/dictionary/i18nBudgetKindItem.js';
import i18nBudgetSourceProperty from './vi/views/dictionary/i18nBudgetSourceProperty.js';
import i18nProject from './vi/views/dictionary/i18nProject.js';
import i18nAccountingObject from './vi/views/dictionary/i18nAccountingObject.js';
import i18nFixedAssetCategory from './vi/views/dictionary/i18nFixedAssetCategory.js';
import i18nOpeningAccountEntry from './vi/views/setup/i18nOpeningAccountEntry.js';
// Dự toán ngân sách
import i18nBUCashWithDraw from './vi/views/budgetPlan/i18nBUCashWithDraw';
import i18nBudgetPlan from './vi/views/budgetPlan/i18nBudgetPlan.js';
import i18nBUTransfer from './vi/views/budgetPlan/i18nBUTransfer.js';
import i18nBUPlanCancel from './vi/views/budgetPlan/i18nBUPlanCancel.js';
import i18nBUAdjustment from './vi/views/budgetPlan/i18nBUAdjustment.js';
import i18nBUPlanAdjustCommit from './vi/views/budgetPlan/i18nBUPlanAdjustCommit.js';
import i18nBUCommitExpense from './vi/views/budgetPlan/i18nBUCommitExpense';
import i18nBUReceiptExpense from './vi/views/budgetPlan/i18nBUReceiptExpense.js';
import i18nBuFinancialActivities from './vi/views/budgetPlan/i18nBuFinancialActivities.js';

// Đối chiếu sử dụng
import i18nDCSDFile from './vi/views/etreasury/i18nDCSDFile.js';
import i18nDCSDReportTemplate from './vi/views/etreasury/i18nDCSDReportTemplate.js';
// Chứng từ QLTS
import i18nFAVoucherData from './vi/views/faVoucherQLTS/i18nFAVoucherData';
import i18nFAVoucherResult from './vi/views/faVoucherQLTS/i18nFAVoucherResult';
import i18nFAVoucherDetail from './vi/views/faVoucherQLTS/i18nFAVoucherDetail';
import i18nFAVoucherList from './vi/views/faVoucherQLTS/i18nFAVoucherList';
import i18nFAVoucherAdjustmentDetail from './vi/views/faVoucherQLTS/i18nFAVoucherAdjustmentDetail';

// Biên Lai
import i18nReceiptSummary from './vi/views/receipt/i18nReceiptSummary';
import i18nReceipt from './vi/views/receipt/i18nReceipt';
import i18nReceiptProcessTab from './vi/views/receipt/i18nReceiptProcessTab';

// Hệ thống
import i18nUserManagement from './vi/views/system/i18nUserManagement';
import i18nCompanyInfo from './vi/views/system/i18nCompanyInfo';
import i18nRole from './vi/views/system/i18nRole';
import i18nQuickReport from './vi/views/system/i18nQuickReport';
import i18nFinanceReportSetting from './vi/views/system/i18nFinanceReportSetting'; // Thiết lập báo cáo tài chính
import i18nBusinessIndex from './vi/views/system/i18nBusinessIndex';
import i18nAdvancedSercurity from './vi/views/system/i18nAdvancedSercurity';
import i18nResultConvert from './vi/views/system/i18nResultConvert';
import i18nRestoreVoucher from './vi/views/system/i18nRestoreVoucher';

import i18nFundStructure from './vi/views/dictionary/i18nFundStructure';
import i18nPlanTemplate from './vi/views/dictionary/i18nPlanTemplate';
// Tệp
import i18nImportExcel from './vi/views/common/import/i18nImportExcel';

// Tổng hợp/Khóa sổ
import i18nLockLedger from './vi/views/summary/i18nLockLedger';
import i18nSUProcess from './vi/views/summary/i18nSUProcess';

// Tiền mặt
import i18nCAReceipt from './vi/views/cash/i18nCAReceipt';
import i18nCAPayment from './vi/views/cash/i18nCAPayment';
import i18nCAAdjustReceipt from './vi/views/cash/i18nCAAdjustReceipt';
import i18nCAAdjustPayment from './vi/views/cash/i18nCAAdjustPayment';
import i18nCAFundInventory from './vi/views/cash/i18nCAFundInventory';

// Quản lý dữ liệu
import i18nDataManagement from './vi/views/system/i18nDataManagement';
import i18nCreateReport from './vi/views/summary/i18nCreateReport';

// Tiền gửi
import i18nDeposits from './vi/views/deposits/i18nDeposits';

// Nhật ký truy cập
import i18nAccessHistory from './vi/views/dictionary/i18nAccessHistory';
// Nhập số dư ban đầu
import i18nAccountBalance from './vi/views/setup/i18nAccountBalance';
// Lương
import i18nSalary from './vi/views/resources/salary/i18nSalary';
import i18nCreateSalaryVoucher from './vi/views/resources/salary/i18nCreateSalaryVoucher';
import i18nSalaryAccountingList from './vi/views/resources/salary/i18nSalaryAccountingList';
import i18nSASalaryPaymentDetail from './vi/views/resources/salary/i18nSASalaryPaymentDetail';
import i18nSASalaryAccountingDetail from './vi/views/resources/salary/i18nSASalaryAccountingDetail';
import i18nSAChooseAccountingVoucher from './vi/views/resources/salary/i18nSAChooseAccountingVoucher';
import i18nSACreateVoucherResult from './vi/views/resources/salary/i18nSACreateVoucherResult';
import i18nVoucherList from './vi/views/resources/salary/i18nVoucherList';
import i18nAccountingInvoice from './vi/views/invoice/i18nAccountingInvoice';
import i18nCreateAccountingVoucher from './vi/views/invoice/i18nCreateAccountingVoucher';

// Inbot invoice

// Tiện ích
import i18nDataMantainance from './vi/views/utility/i18nDataMantainance';
import i18nPostedBatch from './vi/views/utility/i18nPostedBatch';
import i18nGenerateExpenseAccounting from './vi/views/utility/i18nGenerateExpenseAccounting'; // sinh hạch toán chi phí lương, bảo hiểm, kinh phí công đoàn
import i18nGenerating from './vi/views/utility/i18nGenerating'; // Sinh chứng từ
import i18nAct from './vi/views/utility/i18nAct'; // Nhắc nợ

import i18nSATransferTreasuryToDepositAccount from './vi/views/resources/salary/i18nSATransferTreasuryToDepositAccount';
// Thiết lập in báo cáo
import i18nPrintReportSetting from './vi/views/dictionary/i18nPrintReportSetting';

// Sắp xếp lại số chứng từ
import i18nSortRefNo from './vi/views/system/i18nSortRefNo';

// Định dạng số
import i18nFormatNumber from './vi/views/setup/i18nFormatNumber';

import i18nBudgetGroupItem from './vi/views/dictionary/i18nBudgetGroupItem';
import i18nBudgetItem from './vi/views/budgetPlan/i18nBudgetItem';
import i18nBUAdvancePayment from './vi/views/budgetPlan/i18nBUAdvancePayment';
import i18nBUDuplicateTransfer from './vi/views/budgetPlan/i18nBUDuplicateTransfer';
// Báo cáo
import i18nReportList from './vi/views/report/i18nReportList';
import i18nShowReports from './vi/views/report/i18nShowReports';
import i18nReportItemList from './vi/views/report/i18nReportItemList';
import i18nS05axVertical from './vi/views/report/i18nS05axVertical';

// khai báo thông tin ban đầu
import i18nInitialInfoDeclaration from './vi/views/initialInformationDeclaration/i18nInitialInfoDeclaration';
// Tham số báo cáo 02 ngân sách xã
import i18nReportParamCommuneBudget from './vi/views/report/i18nReportParamCommuneBudget';
import i18nReportParam_TT3442016_B02 from './vi/views/report/i18nReportParam_TT3442016_B02';
import i18nHideShowColumn from './vi/dictionary/i18nHideShowColumn';
import i18nCustomTemplate from './vi/dictionary/i18nCustomTemplate';
import i18nBuCreateDeclareTable from './vi/views/budgetPlan/i18nBuCreateDeclareTable';
import i18nReportParam_TT342_626364 from './vi/views/report/i18nReportParam_TT342_626364';
import i18nReportParam_TT312017 from './vi/views/report/i18nReportParam_TT312017';
import i18nC205bTT192020 from './vi/views/report/i18nC205bTT192020';

// Form tham số báo cáo
import i18nC202aNS from './vi/views/report/i18nC202aNS';
import i18nC202bNS from './vi/views/report/i18nC202bNS';
import i18n04aTT from './vi/views/report/i18n04aTT';
import i18nReportParamS04 from './vi/views/report/i18nReportParamS04';
import i18nReportParam_S05b_X from './vi/views/report/i18nReportParam_S05b_X';
import i18nReportParam_S07_X from './vi/views/report/i18nReportParam_S07_X';
import i18nReportParam_S07_X_Year from './vi/views/report/i18nReportParam_S07_X_Year';
import i18nReportParam_06_DCSDTK_KBNN from './vi/views/report/i18nReportParam_06_DCSDTK_KBNN';
import i18nC102NS_TT842016 from './vi/views/report/i18nC102NS_TT842016';
import i18nReportParam_SDKP_DVDT_B01 from './vi/views/report/i18nReportParam_SDKP_DVDT_B01';
import i18nReportParam_C03_CCTT from './vi/views/report/i18nReportParam_C03_CCTT';
import i18nReportParamS21X from './vi/views/report/i18nReportParamS21X';
import i18nReportParam_SDKP_DVDT_B02b from './vi/views/report/i18nReportParam_SDKP_DVDT_B02b';
import i18nReportParamBalanceBudget from './vi/views/report/i18nReportParamBalanceBudget';
import i18nC211NS from './vi/views/report/i18nC211NS';
import i18nC102NS from './vi/views/report/i18nC102NS';
import i18nCheckFormularOverview from './vi/views/report/i18nCheckFormularOverview';

import i18nReport_38_CKTC_NSX from './vi/views/report/i18nReport_38_CKTC_NSX';
import i18nExpenseBudgetTreasuryTB from './vi/views/report/i18nExpenseBudgetTreasuryTB';
import i18nC203NS from './vi/views/report/i18nC203NS';
import i18nReportParamB02bX from './vi/views/report/i18nReportParamB02bX';
//Ngạch lương
import i18nSalaryScale from './vi/dictionary/i18nSalaryScale';

//Sao chép chứng từ
import i18nUtilityCopyVoucherPopup from './vi/views/utility/voucher/i18nUtilityCopyVoucherPopup';

//tìm kiếm chứng từ
import i18nVoucherSearch from './vi/views/system/i18nVoucherSearch';

// Hệ thống tài khoản
import i18nSystemAccount from './vi/dictionary/i18nSystemAccount';
import i18nVoucherAdd from './vi/views/system/i18nVoucherAdd';

// Form tham số nhật ký sổ cái
import i18nReportLedgerLogS01X from './vi/views/report/i18nReportLedgerLogS01X';

// Form tham số sổ cái
import i18nReportLedgerLogS01bX from './vi/views/report/i18nReportLedgerLogS01bX';

// Form tham số sao chép chứng từ Hạch toán lương, BH, KPCĐ
import i18nSaDuplicateSaSalaryAccounting from './vi/views/resources/salary/i18nSaDuplicateSaSalaryAccounting';

//báo cáo c301ns-nd112020
import i18nC301NSND112020 from './vi/views/report/i18nC301NSND112020';
//Form tham số báo caó
import i18n04BTT from './vi/views/report/i18n04BTT';

// B01X báo cáo tài chính bảng cân dối tài khoản
import i18nReportParamAccountBalaceB01X from './vi/views/report/i18nReportParamAccountBalaceB01X';

// Báo cáo Biếu 59
import i18nReportParamB59 from './vi/views/report/i18nReportParamB59.js';

// Báo cáo Biếu 58
import i18nReportParamB58 from './vi/views/report/i18nReportParamB58.js';

//báo cáo S11X tài sản cố định
import i18nS11X from './vi/views/report/i18nS11X';
// C3-02-NS
import i18nReportParamC302NSND112020 from './vi/views/report/i18nReportParamC302NSND112020';
import i18nC402aKBND112020 from './vi/views/report/i18nC402aKBND112020';

// Các báo cáo phải thu, phải trả
import i18nReportParamS10x from './vi/views/report/i18nReportParamS10x';

// Các báo cáo vật tư, vật liệu
import i18nReportParamBS19X from './vi/views/report/i18nReportParamBS19X';
// Báo cáo chứng từ
import i18nPlanReceiptByBudgetListReport from './vi/views/report/i18nPlanReceiptByBudgetListReport';

// Báo cáo công cụ dụng cụ
import i18nReportParamS32H from './vi/views/report/i18nReportParamS32H';
import i18nInventoryReport_stock_remain from './vi/views/report/i18nInventoryReport_stock_remain';

//Form kết nối tới đơn vị khác
import i18nConnectTenant from './vi/views/connect/i18nConnectTenant';

//báo cáo S03X tài sản cố định
import i18nS03X from './vi/views/report/i18nS03X';

// Form tham số PTC quận 4
import i18nVoucherPTCQuan4 from './vi/views/report/i18nVoucherPTCQuan4';

import i18nS22X from './vi/views/report/i18nS22X';

// form tham số băng kê chứng từ PTC
import i18nBKCT_PTC from './vi/views/report/i18nBKCT_PTC';

// form tham số biểu 15 c9217
import i18nReportParamC9217_TT64 from './vi/views/report/i18nReportParamC9217_TT64';

// form tham số biểu 16 c10432
import i18nReportParamC10432_TT64 from './vi/views/report/i18nReportParamC10432_TT64';

// Form tham số Biểu số 15/QTDA: Bảng đối chiếu số liệu (TT số 96/2021/TT-BTC )
import i18nB15_QTDA from './vi/views/report/i18nB15_QTDA';
import i18nB14_QTDA from './vi/views/report/i18nB14_QTDA';

// Danh sách hoá đơn
import i18nInbotInvoices from './vi/views/invoice/i18nInbotInvoices';
import i18nChangeReferenceInvoice from './vi/views/invoice/i18nChangeReferenceInvoice';
import i18nChoooseActivity from './vi/views/report/i18nChoooseActivity';

//Tổng quan
import i18nDashboard from './vi/views/dashboard/i18nDashboard';

//Thiết lập chân chữ ký
import i18nDesignSignature from './vi/dictionary/i18nDesignSignature';

// Tiêu chuẩn định mức
import i18nExpenseNormRegulation from './vi/views/system/i18nExpenseNormRegulation';

import i18nExamniationResult from './vi/views/examinationResult/i18nExamniationResult';

import i18nDataReconciliationQlts from './vi/views/system/i18nDataReconciliationQlts';
export default {
  vi: {
    i18nVoucherType,
    i18nMain,
    i18nValidate,
    i18nComponent,
    i18nEnum,
    i18nCommon,
    i18nBaseForm,
    i18nNumber,
    i18nMonitor,
    i18nHelpLink,
    i18nPages,
    i18nActivityCategory,
    i18nBudgetPlan,
    i18nBUCashWithDraw,
    i18nGeneralVoucher,
    i18nConnectMisaApp,
    i18nOutward,
    i18nFixedAsset,
    i18nLocalBudgetItem,
    i18nInventoryItem,
    i18nStatistic,
    i18nContract,
    i18nSettingFinancialReport,
    i18nPAOption,
    i18nBankInfo,
    i18nSuIncrement,
    i18nAccessHistory,
    i18nSuDecrement,
    i18nSuTransfer,
    i18nEtreasuryProcess,
    i18nDVCSign,
    i18nInInward,
    i18nAccountingObjectCategory,
    i18nHamlet,
    i18nInventoryCategory,
    i18nEquipmentInventoryItem,
    i18nAccountTransfer,
    i18nFAVoucherData,
    i18nFAVoucherResult,
    i18nFAVoucherDetail,
    i18nFAVoucherList,
    i18nReceiptSummary,
    i18nFundStructure,
    i18nReceipt,
    i18nReceiptProcessTab,
    i18nBUReceiveBudgetPlan,
    i18nBUReceipt,
    i18nBUExpense,
    i18nBUTransfer,
    i18nBUPlanCancel,
    i18nBUCommitExpense,
    i18nBUReceiptExpense,
    i18nINTransfer,
    i18nFund,
    i18nActivity,
    i18nBranch,
    i18nDIAccountTransfer,
    i18nDIAutoBusiness,
    i18nDIBudgetProvide,
    i18nDISubBudgetItem,
    i18nUserManagement,
    i18nRestoreVoucher,
    i18nAdvancedSercurity,
    i18nLockLedger,
    i18nSubmitReport,
    i18nCAReceipt,
    i18nCAPayment,
    i18nCAAdjustReceipt,
    i18nCAAdjustPayment,
    i18nCompanyInfo,
    i18nRole,
    i18nQuickReport,
    i18nDataManagement,
    i18nFinanceReportSetting,
    i18nCreateReport,
    i18nDeposits,
    i18nToolsProcess,
    i18nDVCFile,
    i18nDCSDFile,
    i18nDCSDReportTemplate, // Mẫu báo cáo đối chiếu sử dụng
    i18nDefaultImplicitSetting,
    i18nRegimePosted,
    i18nAccountBalance,
    i18nDataMantainance,
    i18nPostedBatch,
    i18nGenerateExpenseAccounting, // sinh hạch toán chi phí lương, bảo hiểm, kinh phí công đoàn
    i18nBUAdjustment,
    i18nActivityCategory,
    i18nSalary,
    i18nCreateSalaryVoucher,
    i18nSalaryAccountingList,
    i18nSASalaryPaymentDetail,
    i18nSASalaryAccountingDetail,
    i18nSAChooseAccountingVoucher,
    i18nSACreateVoucherResult,
    i18nVoucherList,
    i18nPrintReportSetting,
    i18nSUProcess,
    i18nBankInfoCategory,
    i18nListAccountingObject,
    i18nDepartment,
    i18nSortRefNo,
    i18nSATransferTreasuryToDepositAccount,
    i18nImportExcel,
    i18nFormatNumber,
    i18nBUPlanAdjustCommit,
    i18nBudgetGroupItem,
    i18nBudgetChapter,
    i18nBudgetSource,
    i18nBudgetItem,
    i18nBUAdvancePayment,
    i18nBusinessIndex,
    i18nBudgetKindItem,
    i18nBudgetSourceProperty,
    i18nProject,
    i18nOpeningAccountEntry,
    i18nOpeningAccountEntry,
    i18nPlanTemplate,
    i18nReportList,
    i18nShowReports,
    i18nReportItemList,
    i18nReportParam_TT3442016_B02,
    i18nHideShowColumn,
    i18nCustomTemplate,
    i18nReportParamCommuneBudget,
    i18nReport_38_CKTC_NSX,
    i18nInitialInfoDeclaration,
    i18nC202aNS,
    i18nC202bNS,
    i18nReportParam_TT3442016_B02,
    i18nReportParam_TT342_626364,
    i18nAccountingObject,
    i18nBuFinancialActivities,
    i18nBuCreateDeclareTable,
    i18nReportParam_SDKP_DVDT_B01,
    i18nReportParam_SDKP_DVDT_B02b,
    i18nSalaryScale,
    i18nBUDuplicateTransfer,
    i18nUtilityCopyVoucherPopup,
    i18nVoucherSearch,
    i18nSystemAccount,
    i18nVoucherAdd,
    i18nFixedAssetCategory,
    i18nFAVoucherAdjustmentDetail,
    i18nC301NSND112020,
    i18n04BTT,
    i18nReportLedgerLogS01X,
    i18nReportLedgerLogS01bX,
    i18nSaDuplicateSaSalaryAccounting,
    i18n04aTT,
    i18nReportParam_C03_CCTT,
    i18nReportParamS21X,
    i18nReportParamAccountBalaceB01X,
    i18nReportParamS04,
    i18nReportParam_S05b_X,
    i18nPlanReceiptByBudgetListReport,
    i18nReportParam_S07_X,
    i18nReportParam_06_DCSDTK_KBNN,
    i18nS11X,
    i18nReportParamB59,
    i18nReportParamB58,
    i18nS05axVertical,
    i18nReportParamC302NSND112020,
    i18nReportParamS10x,
    i18nReportParamBS19X,
    i18nC402aKBND112020,
    i18nReportParamS32H,
    i18nInventoryReport_stock_remain,
    i18nReportParamBalanceBudget,
    i18nReportParam_S07_X_Year,
    i18nConnectTenant,
    i18nResultConvert,
    i18nExpenseBudgetTreasuryTB,
    i18nS03X,
    i18nC102NS,
    i18nCheckFormularOverview,
    i18nC205bTT192020,
    i18nC102NS_TT842016,
    i18nC211NS,
    i18nVoucherPTCQuan4,
    i18nReportParamC9217_TT64,
    i18nReportParamC10432_TT64,
    i18nC203NS,
    i18nB15_QTDA,
    i18nB14_QTDA,
    i18nS22X,
    i18nBKCT_PTC,
    i18nReportParam_TT312017,
    i18nInbotInvoices,
    i18nAccountingInvoice,
    i18nCreateAccountingVoucher,
    i18nNpsServey,
    i18nChangeReferenceInvoice,
    i18nChoooseActivity,
    i18nDashboard,
    i18nDesignSignature,
    i18nGenerating,
    i18nReportParamB02bX,
    i18nCAFundInventory,
    i18nAct,
    i18nExpenseNormRegulation,
    i18nExamniationResult,
    i18nDataReconciliationQlts,
  },
};
